export default "__VITE_ASSET__670c04f6__"